import React from 'react'
import ReachNativeIFrame from 'components/ReachNativeIFrame'

export const EmailTemplates = () => {
  return (
    <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      <ReachNativeIFrame path="email/templates" />
    </div>
  )
}

export default EmailTemplates
